import {Component} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {Helper} from '../../../helpers/helper.service';
import { filter } from 'rxjs/operators';

interface breadCrumbs {
  label: string,
  icon: boolean,
  caption: boolean,
  status: boolean,
  url: string,
  back: string,
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent {
  tempState = [];
  breadcrumbs: breadCrumbs[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = [];
        this.tempState = [];
          let currentRoute = this.route.root,
          url = '';
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(routes => {
            if (routes.outlet === 'primary') {
              const routeSnapshot = routes.snapshot;
              url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              if (routes.snapshot.data.title !== undefined) {
                let status = true;
                if (routes.snapshot.data.status !== undefined) {
                  status = routes.snapshot.data.status;
                }

                let icon = false;
                if (routes.snapshot.data.icon !== undefined) {
                  icon = routes.snapshot.data.icon;
                }

                let caption = false;
                if (routes.snapshot.data.caption !== undefined) {
                  caption = routes.snapshot.data.caption;
                }
                this.route.data.subscribe(params => {
                  if (Helper.isDefined(params['id'])) {
                  }
                });

                // let back = false;
                // if (routes.snapshot.data.back !== undefined) {
                //   back = routes.snapshot.data.back;
                // }
                if (!this.tempState.includes(routes.snapshot.data.title)) {
                  this.tempState.push(routes.snapshot.data.title);
                  this.breadcrumbs.push({
                    label: routes.snapshot.data.title,
                    icon: icon,
                    caption: caption,
                    status: status,
                    url: url,
                    back: (routes.snapshot.data.back === '') ? routes.snapshot.data.backBreadCrumb : routes.snapshot.data.back
                  });
                }
              }
              currentRoute = routes;
            }
          });
        } while (currentRoute);
      });
  }
}
